import logo from '../assets/images/logo/IpopLogo.svg'
import google from '../assets/images/icon/google.png'
import copyWriting from '../assets/images/icon/copyWriting.svg'
import productPhotos from '../assets/images/icon/productPhotos.svg'
import SocialMedia from '../assets/images/icon/SocialMedia.svg'
import GenerateLeads from '../assets/images/icon/GenerateLeads.svg'
import facebook from '../assets/images/icon/facebook.svg'
import apple from '../assets/images/icon/apple.svg'
import styleImage from '../assets/images/styleImage.png'
import UploadImage from '../assets/images/UploadImage.svg'
import AspectRatio from '../assets/images/AspectRatio.svg'
import Resolution from '../assets/images/Resolution.svg'
import avater from '../assets/images/avater.svg'
import Product1 from '../assets/images/Product1.png'
import Product2 from '../assets/images/product2.png'
import product3 from '../assets/images/product3.png'
import Product4 from '../assets/images/product4.png'
import Product5 from '../assets/images/product5.png'
import Product6 from '../assets/images/product6.png'
import share from '../assets/images/share.svg'
import bg1 from '../assets/images/bg2.svg'
import playIcon from '../assets/images/playIcon.svg'
import earn from '../assets/images/earn.svg'
import styles1 from '../assets/images/styles1.png'
import styles2 from '../assets/images/styles2.png'
import styles3 from '../assets/images/styles3.png'
import styles4 from '../assets/images/styles4.png'
import styles5 from '../assets/images/styles5.png'
import styles6 from '../assets/images/styles6.png'
import uploadI from '../assets/images/icon/uploadI.svg'



export const IMG = {
    uploadI,
    styles1,
    styles2,
    styles3,
    styles4,
    styles5,
    styles6,
    earn,
    bg1,
    playIcon,
    share,
    avater,
    Product1,Product2,product3,
    Product4,Product5,Product6,
    Resolution,
    AspectRatio,
    UploadImage,
    logo,
    google,
    facebook,
    apple,
    copyWriting,
    SocialMedia,
    GenerateLeads,
    productPhotos,
    styleImage
}

export const Menu =[
    {
        id:1,
        name:"home",
        url:"/"
    },
    {
        id:2,
        name:"Collection",
        url:"/dashboard"
    },
    {
        id:3,
        name:"Blogs",
        url:"/blogs"
    },

]

export const Service =[
    {
        id:1,
        name:"Case study",
        url:"/case-study"
    },
    {
        id:2,
        name:"Features",
        url:"/features"
    }
]

export const Company =[
    {
        id:1,
        name:"FAQ",
        url:"/case-study"
    },
    {
        id:2,
        name:"Video tutorial",
        url:"/features"
    }
]

export const ContactUs =[
    {
        id:1,
        name:"Privacy",
        url:"/privacy"
    },
    {
        id:2,
        name:"Terms of services",
        url:"/terms-services"
    }
]
